import { EPDWrapper } from "@opstel/EPD/components/EPDWrapper";
import { RetShiftsWrapper } from "@opstel/RET/RetShiftsWrapper";
import { ServiceTasksWrapper } from "@opstel/serviceTasks/ServiceTasksWrapper";
import { SBDWrapper } from "@opstel/SBD/components/SBDWrapper";
import { KlussenOverviewWrapper } from "@personeel/components/KlussenOverview/KlussenOverviewWrapper";
import { WerklijnenWrapper } from "@personeel/components/Werklijnen/WerklijnenWrapper";
import { Navigate, RouteObject } from "react-router-dom";
import { AppLayout } from "../components/layout/AppLayout";
import { ErrorPage } from "../ErrorPage";

export const appRoutes = {
  HOME: "/",
  SBD: "/sbd",
  EPD: "/epd",
  RET_SHIFTS_OVERVIEW: "/hip/retshifts",
  SERVICETAKEN: "/hip/servicetaken",
  PERSONEEL: "/personeel",
  PERSONEEL_WERKLIJNEN: "/personeel-werklijnen",
  ERROR_404: "*",
  ERROR_500: "forbidden",
} as const;

export function getRoutes(homePage: keyof typeof appRoutes = "SBD"): RouteObject[] {
  return [
    {
      path: "/",
      element: <AppLayout />,
      children: [
        { path: appRoutes.HOME, element: <Navigate replace to={homePage} /> },
        {
          path: appRoutes.SBD,
          element: <SBDWrapper />,
        },
        {
          path: appRoutes.EPD,
          element: <EPDWrapper />,
        },
        {
          path: appRoutes.RET_SHIFTS_OVERVIEW,
          element: <RetShiftsWrapper />,
        },
        {
          path: appRoutes.SERVICETAKEN,
          element: <ServiceTasksWrapper />,
        },
        {
          path: appRoutes.PERSONEEL,
          element: <KlussenOverviewWrapper />,
        },
        {
          path: appRoutes.PERSONEEL_WERKLIJNEN,
          element: <WerklijnenWrapper />,
        },
        { path: appRoutes.ERROR_404, element: <ErrorPage /> },
        { path: appRoutes.ERROR_500, element: <ErrorPage /> },
      ],
    },
  ];
}
